import { createFileRoute } from "@tanstack/react-router";

import { OverviewPage } from "../../../../areas/admin/overview/OverviewPage";

/** `/app/admin`: "Resumen" (FE-14 FR-FE14-03). */
export const Route = createFileRoute("/app/_seller/admin/")({
  component: OverviewPage,
});
